import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch, Redirect } from "react-router-dom";

import { Header, Footer, Sidebar } from "components";

import dashboardRoutes from "routes/dashboard.jsx";
import Bills from "views/Bills/BillsGlobalStatus.jsx";
import BillsReturned from "views/Bills/BillsReturned.jsx";
import BillsReturnedList from "views/Bills/BillsReturnedList.jsx";
import BillsProviders from "views/Bills/BillsProviders.jsx";
import BillDetail from "views/Bills/BillDetail.jsx";
import Customers from "views/Customers/CustomersList.jsx";
import CustomerProfile from "views/Customers/CustomerProfile.jsx";
import CustomerMobile from "views/Customers/CustomerMobile.jsx";
import CustomerMobileRegistries from "views/Customers/CustomerMobileRegistries.jsx";
import Mobiles from "views/Mobiles/MobilesList.jsx";
import MobileDetail from "views/Mobiles/MobileDetail.jsx";
import DashboardPanel from "views/Dashboard/Dashboard.jsx";
import Configuration from "views/Configuration/Configuration.jsx";
import Notifications from "views/Notifications/Notifications.jsx";
import MobileProcedure from "views/MobileProcedures/MobileProceduresList.jsx";
import CustomerWizard from "views/Customers/CustomerWizard/CustomerWizard.jsx";
import MobileRequest from "views/Web/MobileWebRequestList.jsx";
import NewContract from "../../views/Contracts/NewContract";
import ContractsList from "../../views/Contracts/ContractsList";
import ViewContract from "../../views/Contracts/ViewContract";
import EditContract from "../../views/Contracts/EditContract";
import Pegasus from "views/Pegasus/Pegasus";
import Cajas from "views/CashRegisters/CashRegistersList.jsx";
import CajaDetalle from "views/CashRegisters/CashRegisterDetail.jsx";
import HomeVisitsList from "views/HomeVisits/HomeVisitsList.jsx";
import ViewHomeVisit from "views/HomeVisits/ViewHomeVisit.jsx";
import NewHomeVisit from "views/HomeVisits/NewHomeVisit.jsx";
import Calendar from "views/Calendar/Calendar.jsx";
import Tools from "views/Tools/Tools.jsx";
import Tickets from "views/Tickets/Tickets.jsx";
import ViewTicket from "views/Tickets/ViewTicket.jsx";
import NewTicket from "views/Tickets/NewTicket.jsx";
import Coverage from "views/Coverage/Coverage.jsx";
import Tasks from "views/Tasks/Tasks.jsx";
import WebContent from "views/Web/WebContent.jsx";
import WebContentDetails from "views/Web/WebContentDetails.jsx";
import Roulette from "views/Roulette/Roulette.jsx";
import RouletteDashboard from "views/Roulette/RouletteDashboard.jsx";
import RouletteResults from "views/Roulette/RouletteResults.jsx";
// import FaceDetection from "views/FaceDetection/FaceDetection.jsx";
import Reminders from "../../views/Reminders/Reminders";
import NewReminder from "../../views/Reminders/NewReminder";
import ViewReminder from "../../views/Reminders/ViewReminder";
import BillsSearch from "../../views/Bills/BillsSearch";
import Users from "../../views/Users/Users";
import Log from "../../views/Log/Log";
// import FaceDetectionTest from "../../views/FaceDetection/FaceDetectionTest";

var ps;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    //this.startLogin = this.startLogin.bind(this);
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(this.refs.mainPanel);
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.documentElement.className += " perfect-scrollbar-off";
      document.documentElement.classList.remove("perfect-scrollbar-on");
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
    // console.log("####  TEST DIDUPDATE ####");
    // console.log(e);
    // window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className="wrapper">
        <Sidebar {...this.props} routes={dashboardRoutes} mainState={this.props.mainState} userData={this.props}/>
        <div className="main-panel" ref="mainPanel">
          <Header {...this.props} signOut={this.props.signOut} />
          <Switch>
            <Route
              exact
              path="/dashboard"
              render={props =>
                <DashboardPanel {...props} userData={this.props} mainState={this.props.mainState} loadInternet={this.props.loadInternet}
                  startWheel={this.props.startWheel}
                />
              } />
            <Route
              exact
              path="/usuarios"
              render={props =>
                <Users {...props} {...this.props} userData={this.props} mainState={this.props.mainState} loadInternet={this.props.loadInternet}/>
              } />
            <Route
              exact
              path="/log"
              render={props =>
                <Log {...props} {...this.props} userData={this.props} mainState={this.props.mainState} loadInternet={this.props.loadInternet}/>
              } />
            {/* <Route
              exact
              path="/configurar"
              render={props =>
                <Configure {...props} {...this.props} userData={this.props} mainState={this.props.mainState} />
              } /> */}
            {/* <Route
              exact
              path="/configuracion/cara"
              render={props =>
                <FaceDetection {...props} {...this.props} userData={this.props} mainState={this.props.mainState} />
              } /> */}
            {/* <Route
              exact
              path="/entrar/cara"
              render={props =>
                <FaceDetection {...props} {...this.props} userData={this.props} mainState={this.props.mainState} />
              } /> */}
            {/* <Route
              exact
              path="/facetest"
              render={props =>
                <FaceDetectionTest {...props} {...this.props} userData={this.props} mainState={this.props.mainState} loadInternet={this.props.loadInternet}/>
              } /> */}
            <Route
              exact
              path="/configuracion"
              render={props =>
                <Configuration {...props} {...this.props} userData={this.props} mainState={this.props.mainState} loadInternet={this.props.loadInternet}/>
              } />
            <Route
              exact
              path="/notificaciones"
              render={props =>
                <Notifications {...this.props}/>
              } />
            <Route
              exact
              path="/citas"
              render={props =>
                <HomeVisitsList
                  {...props}
                  setSearchCustomerQuery={this.props.setSearchCustomerQuery}
                  searchCustomer={this.props.searchCustomer}
                  userData={this.props}
                  mainState={this.props.mainState}
                  createMobileProcedure={this.props.createMobileProcedure}
                  searchMobileProcedures={this.props.searchMobileProcedures}
                  cancelMobileProcedure={this.props.cancelMobileProcedure}
                  getContractProducts={this.props.getContractProducts}
                  createContract={this.props.createContract}
                  searchContracts={this.props.searchContracts}
                  loadContractTemplates={this.props.loadContractTemplates}
                  createCustomerFromContract={this.props.createCustomerFromContract}
                  getContract={this.props.getContract}
                  deleteContract={this.props.deleteContract}
                  getContractsCount={this.props.getContractsCount}
                />
              } />
            <Route
              exact
              path="/citas/nueva"
              render={props =>
                <NewHomeVisit
                  {...props}
                  userData={this.props}
                  mainState={this.props.mainState}
                  getRelatedContracts={this.props.getRelatedContracts}
                />
              } />
            <Route
              exact
              path="/citas/:homeVisit"
              render={props =>
                <ViewHomeVisit
                  {...this.props}
                  {...props}
                  userData={this.props}
                  mainState={this.props.mainState}
                />
              } />
            <Route
              exact
              path="/citas/editar/:homeVisit"
              render={props =>
                <NewHomeVisit
                  {...this.props}
                  {...props}
                  userData={this.props}
                  mainState={this.props.mainState}
                />
              } />
            <Route
              exact
              path="/calendario"
              render={props =>
                <Calendar
                  {...props}
                  {...this.props}
                  userData={this.props}
                  mainState={this.props.mainState}
                  saveSessionConfig={this.props.saveSessionConfig}
                />
              } />
            <Route
              exact
              path="/recordatorios"
              render={props =>
                <Reminders
                  {...props}
                  {...this.props}
                  userData={this.props}
                  mainState={this.props.mainState}
                  saveSessionConfig={this.props.saveSessionConfig}
                />
              } />
            <Route
              exact
              path="/recordatorios/nuevo"
              render={props =>
                <NewReminder
                  {...props}
                  {...this.props}
                  userData={this.props}
                  mainState={this.props.mainState}
                  saveSessionConfig={this.props.saveSessionConfig}
                />
              } />
            <Route
              exact
              path="/recordatorios/:reminderId"
              render={props =>
                <ViewReminder
                  {...this.props}
                  {...props}
                  userData={this.props}
                  mainState={this.props.mainState}
                />
              } />
            <Route
              exact
              path="/cajas"
              render={props =>
                <Cajas
                  {...props}
                  getCashRegistersList={this.props.getCashRegistersList}
                  userData={this.props}
                  mainState={this.props.mainState}
                />
              }/>
            <Route
              exact
              path="/cajas/:cashRegisterId"
              render={props =>
                <CajaDetalle
                  {...props}
                  getCashRegistersList={this.props.getCashRegistersList}
                  createCashRegistry={this.props.createCashRegistry}
                  userData={this.props}
                  mainState={this.props.mainState}
                />
              }/>
            <Route
              exact
              path="/facturas"
              render={props =>
                <Bills 
                {...props} 
                userData={this.props} 
                mainState={this.props.mainState}
                searchBills={this.props.searchBills}
                editBill={this.props.editBill}/>
              } />
              <Route
                exact
                path="/facturas/buscar"
                render={props =>
                  <BillsSearch
                  {...props} 
                  userData={this.props} 
                  mainState={this.props.mainState}
                  searchBills={this.props.searchBills}
                  editBill={this.props.editBill}/>
                } />
              <Route
                exact
                path="/facturas/morosos"
                render={props =>
                  <BillsReturned
                  {...props} 
                  userData={this.props} 
                  mainState={this.props.mainState}
                  searchBills={this.props.searchBills}
                  editBill={this.props.editBill}/>
                } />
              <Route
                exact
                path="/facturas/morosos/lista"
                render={props =>
                  <BillsReturnedList 
                  {...props} 
                  userData={this.props} 
                  mainState={this.props.mainState}
                  searchBills={this.props.searchBills}
                  editBill={this.props.editBill}/>
                } />
              <Route
                exact
                path="/facturas/proveedores"
                render={props =>
                  <BillsProviders
                  {...props} 
                  userData={this.props} 
                  mainState={this.props.mainState}
                  searchBills={this.props.searchBills}
                  editBill={this.props.editBill}/>
                } />
            <Route
              path="/facturas/:orderNumber"
              render={props =>
                <BillDetail {...props} 
                  userData={this.props}
                  mainState={this.props.mainState}
                  getOrdersArticles={this.props.getOrdersArticles} 
                  getOrderID={this.props.getOrderID}
                  getCustomerNotes={this.props.getCustomerNotes}
                  createNote={this.props.createNote}/>
              } />
            {/* <Route
              exact
              path="/movil"
              render={props =>
                <Bills {...props} userData={this.props} mainState={this.props.mainState} />
              } /> */}
            <Route
              exact
              path="/movil"
              render={props =>
                <Mobiles {...props} userData={this.props} 
                  mainState={this.props.mainState}
                  getCustomersMobiles={this.props.getCustomersMobiles} />
              } />
            <Route
              path="/movil/:mobileNumber"
              render={props =>
                <MobileDetail {...props} userData={this.props} mainState={this.props.mainState} />
              } />
            <Route
              exact
              path="/clientes"
              render={props =>
                <Customers
                  {...props}
                  setSearchCustomerQuery={this.props.setSearchCustomerQuery}
                  searchCustomer={this.props.searchCustomer}
                  userData={this.props}
                  mainState={this.props.mainState}
                  showNotification={this.props.showNotification}
                />
              } />
              <Route
                exact
                path="/clientes/crear"
                render={props =>
                  <CustomerWizard
                    {...props}
                    mainState={this.props.mainState}
                    createCustomer={this.props.createCustomer}
                  />
                } />
              <Route
                exact
                path="/clientes/fichas/:customerID"
                render={props =>
                  <CustomerProfile
                    {...props}
                    setSearchCustomerQuery={this.props.setSearchCustomerQuery}
                    searchCustomer={this.props.searchCustomer}
                    userData={this.props}
                    mainState={this.props.mainState}
                    createMobileProcedure={this.props.createMobileProcedure}
                    searchMobileProcedures={this.props.searchMobileProcedures}
                    cancelMobileProcedure={this.props.cancelMobileProcedure}
                    getCustomerNotes={this.props.getCustomerNotes}
                    createNote={this.props.createNote}
                    setCustomerInternetPlan={this.props.setCustomerInternetPlan}
                    toggleCustomerInternetService={this.props.toggleCustomerInternetService}
                    setCustomerIBAN={this.props.setCustomerIBAN}
                    switchCustomerRenewal={this.props.switchCustomerRenewal}
                    createCustomerMobile={this.props.createCustomerMobile}
                    createExtraExpenseWrapper={this.props.createExtraExpenseWrapper}
                    modifyMobileServicesWrapper={this.props.modifyMobileServicesWrapper}
                    getCustomerExtraExpenses={this.props.getCustomerExtraExpenses}
                    searchSIMDeliveries={this.props.searchSIMDeliveries}
                    createSIMDelivery={this.props.createSIMDelivery}
                    searchWebMobileRequests={this.props.searchWebMobileRequests}
                    searchBills={this.props.searchBills}
                    editBill={this.props.editBill}
                    searchBulkCustomer={this.props.searchBulkCustomer}
                    changeClientPassword={this.props.changeClientPassword}
                    editCustomer={this.props.editCustomer}
                    edit_tv_subscription={this.props.edit_tv_subscription}
                    searchCustomerContracts={this.props.searchCustomerContracts}
                    setExistingCustomerForContract={this.props.setExistingCustomerForContract}
                    list_support_tickets={this.props.list_support_tickets}
                    searchBillsByCustomerID={this.props.searchBillsByCustomerID}
                    confirmSIMDelivery={this.props.confirmSIMDelivery}
                    getSIMDeliveryTypes={this.props.getSIMDeliveryTypes}
                    searchCustomerSecret={this.props.searchCustomerSecret}
                    getSecretsTraffic={this.props.getSecretsTraffic}
                    cleanContract={this.props.cleanContract}
                    getPaymentLink={this.props.getPaymentLink}
                    getCustomerOrders={this.props.getCustomerOrders}
                  />
                } 
              />
              <Route
                exact
                path="/clientes/fichas/:customerID/movil/:mobileNumber"
                render={props =>
                  <CustomerMobile
                    {...props}
                    setSearchCustomerQuery={this.props.setSearchCustomerQuery}
                    searchCustomer={this.props.searchCustomer}
                    getMobileCDR={this.props.getMobileCDR}
                    getMobileCDRShort={this.props.getMobileCDRShort}
                    userData={this.props}
                    mainState={this.props.mainState}
                    getMobileServices={this.props.getMobileServices}
                    modifyMobileServicesWrapper={this.props.modifyMobileServicesWrapper}
                    showNotification={this.props.showNotification}
                    getTodayDataUsage={this.props.getTodayDataUsage}
                    getMobileServicesAPI={this.props.getMobileServicesAPI}
                  />
                } 
              />
              <Route
                exact
                path="/clientes/fichas/:customerID/movil/:mobileNumber/registros"
                render={props =>
                  <CustomerMobileRegistries
                    {...props}
                    setSearchCustomerQuery={this.props.setSearchCustomerQuery}
                    searchCustomer={this.props.searchCustomer}
                    getMobileCDR={this.props.getMobileCDR}
                    getMobileCDRShort={this.props.getMobileCDRShort}
                    userData={this.props}
                    mainState={this.props.mainState}
                    getMobileServices={this.props.getMobileServices}
                    modifyMobileServicesWrapper={this.props.modifyMobileServicesWrapper}
                    showNotification={this.props.showNotification}
                    getTodayDataUsage={this.props.getTodayDataUsage}
                    getMobileServicesAPI={this.props.getMobileServicesAPI}
                  />
                } 
              />
              <Route
                exact
                path="/tramites"
                render={props =>
                  <MobileProcedure
                    {...props}
                    setSearchCustomerQuery={this.props.setSearchCustomerQuery}
                    searchCustomer={this.props.searchCustomer}
                    userData={this.props}
                    mainState={this.props.mainState}
                    createMobileProcedure={this.props.createMobileProcedure}
                    searchMobileProcedures={this.props.searchMobileProcedures}
                    cancelMobileProcedure={this.props.cancelMobileProcedure}
                  />
                } />
              <Route
                exact
                path="/contratos"
                render={props =>
                  <ContractsList
                    {...props}
                    setSearchCustomerQuery={this.props.setSearchCustomerQuery}
                    searchCustomer={this.props.searchCustomer}
                    userData={this.props}
                    mainState={this.props.mainState}
                    createMobileProcedure={this.props.createMobileProcedure}
                    searchMobileProcedures={this.props.searchMobileProcedures}
                    cancelMobileProcedure={this.props.cancelMobileProcedure}
                    getContractProducts={this.props.getContractProducts}
                    createContract={this.props.createContract}
                    searchContracts={this.props.searchContracts}
                    loadContractTemplates={this.props.loadContractTemplates}
                    createCustomerFromContract={this.props.createCustomerFromContract}
                    getContract={this.props.getContract}
                    deleteContract={this.props.deleteContract}
                    getContractsCount={this.props.getContractsCount}
                    cleanContract={this.props.cleanContract}
                    getContractURL={this.props.getContractURL}
                    deleteContractAsync={this.props.deleteContractAsync}
                  />
                } />
              <Route
                exact
                path="/contratos/nuevo"
                render={props =>
                  <NewContract
                    {...props}
                    setSearchCustomerQuery={this.props.setSearchCustomerQuery}
                    searchCustomer={this.props.searchCustomer}
                    userData={this.props}
                    mainState={this.props.mainState}
                    createMobileProcedure={this.props.createMobileProcedure}
                    searchMobileProcedures={this.props.searchMobileProcedures}
                    cancelMobileProcedure={this.props.cancelMobileProcedure}
                    getContractProducts={this.props.getContractProducts}
                    createContract={this.props.createContract}
                    cleanContract={this.props.cleanContract}
                    setExistingCustomerForContract={this.props.setExistingCustomerForContract}
                    setProductsForContract={this.props.setProductsForContract}
                    searchBulkCustomer={this.props.searchBulkCustomer}
                  />
                } />
              <Route
                exact
                path="/contratos/:contract_id"
                render={props =>
                  <ViewContract
                    {...props}
                    setSearchCustomerQuery={this.props.setSearchCustomerQuery}
                    searchCustomer={this.props.searchCustomer}
                    userData={this.props}
                    mainState={this.props.mainState}
                    createMobileProcedure={this.props.createMobileProcedure}
                    searchMobileProcedures={this.props.searchMobileProcedures}
                    cancelMobileProcedure={this.props.cancelMobileProcedure}
                    getContractProducts={this.props.getContractProducts}
                    createContract={this.props.createContract}
                    searchContracts={this.props.searchContracts}
                    loadContractTemplates={this.props.loadContractTemplates}
                    getContract={this.props.getContract}
                    closeContract={this.props.closeContract}
                    cleanContract={this.props.cleanContract}
                    searchBulkCustomer={this.props.searchBulkCustomer}
                    createCustomerFromContract={this.props.createCustomerFromContract}
                  />
                } />
                <Route
                  exact
                  path="/contratos/editar/:contract_id"
                  render={props =>
                    <EditContract
                      {...props}
                      setSearchCustomerQuery={this.props.setSearchCustomerQuery}
                      searchCustomer={this.props.searchCustomer}
                      userData={this.props}
                      mainState={this.props.mainState}
                      createMobileProcedure={this.props.createMobileProcedure}
                      searchMobileProcedures={this.props.searchMobileProcedures}
                      cancelMobileProcedure={this.props.cancelMobileProcedure}
                      getContractProducts={this.props.getContractProducts}
                      createContract={this.props.createContract}
                      searchContracts={this.props.searchContracts}
                      loadContractTemplates={this.props.loadContractTemplates}
                      getContract={this.props.getContract}
                      closeContract={this.props.closeContract}
                      editContract={this.props.editContract}
                      cleanContract={this.props.cleanContract}
                      resendContract={this.props.resendContract}
                      searchBulkCustomer={this.props.searchBulkCustomer}                      
                    />
                  } />
              <Route
                exact
                path="/web"
                render={props =>
                  <WebContent
                    {...this.props}
                  />
                } />
              <Route
                exact
                path="/web/detalles/:webformId"
                render={props =>
                  <WebContentDetails
                    {...props}
                    userData={this.props}
                    mainState={this.props.mainState}
                  />
                } />
              <Route
                exact
                path="/web/solicitudes-movil"
                render={props =>
                  <MobileRequest
                    {...props}
                    setSearchCustomerQuery={this.props.setSearchCustomerQuery}
                    searchCustomer={this.props.searchCustomer}
                    userData={this.props}
                    mainState={this.props.mainState}
                    createMobileProcedure={this.props.createMobileProcedure}
                    searchMobileProcedures={this.props.searchMobileProcedures}
                    cancelMobileProcedure={this.props.cancelMobileProcedure}
                    searchWebMobileRequests={this.props.searchWebMobileRequests}
                    setSearchWebMobileRequestsQuery={this.props.setSearchWebMobileRequestsQuery}
                    getWebMobileRequestDocuments={this.props.getWebMobileRequestDocuments}
                    createCustomerFromWebRequest={this.props.createCustomerFromWebRequest}
                  />
                } />
              <Route
                exact
                path="/herramientas"
                render={props =>
                  <Tools {...props} 
                    userData={this.props} 
                    mainState={this.props.mainState} 
                    loadInternet={this.props.loadInternet}
                    confirmSIMDelivery={this.props.confirmSIMDelivery}
                    />
                } />
              <Route
                exact
                path="/herramientas/:tool"
                render={props =>
                  <Tools {...props} 
                    userData={this.props} 
                    mainState={this.props.mainState} 
                    loadInternet={this.props.loadInternet}
                    confirmSIMDelivery={this.props.confirmSIMDelivery}
                    />
                } />
              <Route
                exact
                path="/ruleta"
                render={props =>
                  <RouletteDashboard 
                    {...props}
                  />
                } 
              />
              <Route
                exact
                path="/ruleta/jugar"
                render={props =>
                  <Roulette 
                    {...props} 
                    startWheel={this.props.startWheel}
                    sendWheelForm={this.props.sendWheelForm}
                  />
                } 
              />
              <Route
                exact
                path="/ruleta/resultados"
                render={props =>
                  <RouletteResults 
                    {...props}
                    userData={this.props} 
                  />
                } 
              />
              <Route
                exact
                path="/tickets"
                render={props =>
                  <Tickets 
                    {...props}
                    {...this.props} 
                    userData={this.props} 
                    mainState={this.props.mainState} 
                    loadInternet={this.props.loadInternet}
                    confirmSIMDelivery={this.props.confirmSIMDelivery}
                    />
                } />
                <Route
                  exact
                  path="/tickets/nuevo"
                  render={props =>
                    <NewTicket
                      {...this.props}
                      {...props}
                      userData={this.props}
                      mainState={this.props.mainState}
                    />
                  } />
                <Route
                  exact
                  path="/tickets/:ticket"
                  render={props =>
                    <ViewTicket
                      {...this.props}
                      {...props}
                      userData={this.props}
                      mainState={this.props.mainState}
                    />
                  } />
              <Route
                exact
                path="/pegasus"
                render={props =>
                  <Pegasus
                    {...props}
                    app={this.props}
                    mainState={this.props.mainState}
                  />
                } />
              <Route
                exact
                path="/tareas"
                render={props =>
                  <Tasks
                    {...this.props}
                    {...props}
                    userData={this.props}
                    mainState={this.props.mainState}
                  />
                } />
            {dashboardRoutes.map((prop, key) => {
              if (prop.collapse) {
                return prop.views.map((prop2, key2) => {
                  return (
                    <Route
                      path={prop2.path}
                      component={prop2.component}
                      key={key2}
                    />
                  );
                });
              }
              if (prop.redirect)
                return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            })}
          </Switch>
          {// we don't want the Footer to be rendered on full screen maps page
          this.props.location.pathname.indexOf("full-screen-maps") !==
          -1 ? null : (
            <Footer fluid />
          )}
        </div>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx